import { CardGridComponent } from './CardGrid.types'

export const CardGrid: CardGridComponent = ({ dataSource, renderItem }) => (
  <ul className="max-w-sm mx-auto grid gap-10 sm:max-w-none sm:grid sm:grid-cols-2 sm:gap-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
    {dataSource.map(renderItem)}
  </ul>
)
